export enum BlockPeriodTypeEnum {
  FOOD_GROUP = 'FOOD_GROUP',
  INDIVIDUAL = 'INDIVIDUAL',
  INSTRUCTION = 'INSTRUCTION',
  EXERCISE = 'EXERCISE',
}
